import { Flyer } from '@/graphql/types';
import { TrackingFrom } from '@/hooks';
import { BodySmall, TitleSmallEmphasized } from '@/design-system';
import colors from '@/theme/colors';
import { FlyerDetailsSwiper } from '../FlyerDetailsSwiper';
import styles from './PendingFlyerDetails.styles';
import { FlyerDetailsNavBar } from '../FlyerDetailsNavBar/FlyerDetailsNavBar';
import { FlyerDetailsBottom } from '../FlyerDetailsBottom';

interface Props {
  backButton: () => void;
  flyer: Flyer;
  trackingFrom: TrackingFrom;
  loadingFlyer: boolean;
  onLoadFlyer: () => void;
  flyerTitle: string;
}

export const PendingFlyerDetails: React.FC<Props> = ({
  backButton,
  flyer,
  trackingFrom,
  loadingFlyer,
  onLoadFlyer,
  flyerTitle,
}) => (
  <div className={styles.container}>
    <FlyerDetailsNavBar onClick={backButton} iconPosition="right" />
    <main>
      <FlyerDetailsSwiper
        flyerTitle={flyerTitle}
        flyer={flyer}
        loadingFlyer={loadingFlyer}
        isPending
        onLoadFlyer={onLoadFlyer}
        slideSwiper={() => null}
        trackingFrom={trackingFrom}
      />
      <div className={styles.content}>
        <div className={styles.subHeader}>
          <BodySmall color={colors.stone}>This flyer will be posted once approved</BodySmall>
          <BodySmall color={colors.stone}>Flyer ID {flyer.flyerId}</BodySmall>
        </div>
        <TitleSmallEmphasized color={colors.neutralAsh}>{flyerTitle}</TitleSmallEmphasized>
      </div>
      <div className={styles.footer}>
        <FlyerDetailsBottom ctas={flyer.ctas} />
      </div>
    </main>
  </div>
);
